import { Svg } from '@/shared/ui/Svg';
import { PrivateFileLink } from '@/shared/ui/PrivateFileLink';
import { formatFileSize } from '@/shared/utils';
import type { FileInfo } from '@/shared/types/files';
import TrashIcon from '@/shared/assets/icons/trash.svg';

interface IProps {
  file: FileInfo;
  handleRemoveFile?: (key: string) => void;
}

export const DataBaseFileItem = ({ file, handleRemoveFile }: IProps) => (
  <li className="flex justify-between items-center gap-2 p-1 bg-neutral-hover rounded-md">
    <PrivateFileLink
      file={file}
      className="min-w-0 truncate hover:underline text-black-headline"
    />
    <div className="flex shrink-0 items-center gap-2">
      <span className="whitespace-nowrap text-sm text-grey-secondary">
        {formatFileSize(file.size)}
      </span>
      {handleRemoveFile && (
        <button
          type="button"
          onClick={() => handleRemoveFile(file.key)}
          className="cursor-pointer"
        >
          <Svg Icon={TrashIcon} width={18} />
        </button>
      )}
    </div>
  </li>
);
